export default __webpack_public_path__ + "static/media/koreio.0b5d771e.svg";